import { CourseDef } from '../../../../types';
import L2084297 from './2084297';
import L3893657 from './3893657';
import L3893658 from './3893658';
import L3893662 from './3893662';
import L3893663 from './3893663';
import L3893676 from './3893676';
import L3893677 from './3893677';
import L3893678 from './3893678';
import L3893665 from './3893665';
import L3893679 from './3893679';
// import L5234461 from './5234461';
import L5234462 from './5234462';

export const priceAction: CourseDef = {
  courseTitle: 'PRICE ACTION',
  lessons: [
    L2084297,
    L3893657,
    L3893658,
    L3893662,
    L3893663,
    L3893676,
    L3893677,
    L3893678,
    L3893665,
    L3893679,
    // L5234461,
    L5234462,
  ],
};

